export default __webpack_public_path__ + "static/media/type.171ddc1d.svg";